import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20d8376c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "page-tab-content" }
const _hoisted_3 = ["path", "onClick"]

import { ref, computed, type PropType, reactive, watch, StyleValue } from 'vue';
import { useVModel } from '@vueuse/core';
import { TabPageItem } from '@/@types';
import { state as pageTabState, service as pageTabService } from '@/modules/page-tab';
import { message } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageTabs',
  props: {
  /** 页面列表 */
  tabList: {
    type: Array as PropType<TabPageItem[]>,
    default: () => [],
  },
  /** 当前下标 */
  activeKey: {
    type: String,
    default: '',
  },
},
  emits: ['update:tabList', 'update:activeKey'],
  setup(__props, { emit }) {

const props = __props;





const tabList = useVModel(props, 'tabList', emit);

const activeKey = useVModel(props, 'activeKey', emit);

const state = reactive({
  /** 隐藏的标签项 */
  hiddenTabItems: [] as TabPageItem[],
  /** 滚动条样式 */
  progressStyle: {
    visibility: 'hidden',
    transform: `translate(0px, 0px)`,
    width: `0px`,
  } as Record<string, string>,
  /** 是否滚动条在最左侧 */
  isScrollMin: false,
  /** 是否滚动条在最右侧 */
  isScrollMax: false,
});

/** 可滚动的Tab */
const elPageTabList = ref<HTMLElement>();
/** 滚动条 */
const elPageTabListProgress = ref<HTMLElement>();

/** 滚动条位置 */
const resetProgressStyle = () => {
  let _left = 0;
  let _width = 0;
  let _isHide = false;
  const _elPageTabList = elPageTabList.value;
  if (_elPageTabList) {
    if (Math.abs(_elPageTabList.offsetWidth - _elPageTabList.scrollWidth) < 10) _isHide = true;
    else {
      _left = _elPageTabList.offsetWidth * (_elPageTabList.scrollLeft / _elPageTabList.scrollWidth);
      _width = _elPageTabList.offsetWidth * (_elPageTabList.offsetWidth / _elPageTabList.scrollWidth);
    }
  }
  state.progressStyle = {
    visibility: _isHide ? 'hidden' : 'visible',
    transform: `translate(${_left}px, 0px)`,
    width: `${_width}px`,
  };
};

/** 切换当前页面标签 */
const change = (index: number) => {
  pageTabService.changeTab(index);
};

/** 向左滚动 */
const turnLeft = () => {
  if (elPageTabList.value) {
    elPageTabList.value.scrollBy({
      left: -140,
      top: 0,
      behavior: 'smooth',
    });
  }
};

const turnRight = () => {
  if (elPageTabList.value) {
    elPageTabList.value.scrollBy({
      left: +140,
      top: 0,
      behavior: 'smooth',
    });
  }
};

/** 重设隐藏标签项 */
const resetHiddenTabItems = () => {
  if (elPageTabList.value) {
    const _scrollLeft = elPageTabList.value.scrollLeft;
    const _fullWidth = elPageTabList.value.offsetWidth;
    state.hiddenTabItems = (Array.from(elPageTabList.value.children) as HTMLElement[])
      .filter(i => {
        return i.offsetLeft > _scrollLeft + _fullWidth || i.offsetLeft + i.offsetWidth < _scrollLeft;
      })
      .map(el => {
        return tabList.value.find(i => i.fullPath === el.getAttribute('path'));
      })
      .filter(i => i) as TabPageItem[];
  } else {
    state.hiddenTabItems = [];
  }
};

/** 重设滚动条配置 */
const resetScrollConfig = () => {
  if (elPageTabList.value) {
    const _scrollLeft = Math.round(elPageTabList.value.scrollLeft);
    state.isScrollMin = _scrollLeft < 5;
    state.isScrollMax = elPageTabList.value.scrollWidth - _scrollLeft - elPageTabList.value.offsetWidth < 5;
  }
};

watch(
  () => props.tabList,
  (newVal, oldVal) => {
    resetHiddenTabItems();
    resetProgressStyle();
    resetScrollConfig();
  },
  { deep: true },
);

window.addEventListener('resize', () => {
  resetHiddenTabItems();
  resetProgressStyle();
  resetScrollConfig();
});

setTimeout(() => {
  resetHiddenTabItems();
  resetProgressStyle();
  resetScrollConfig();

  if (elPageTabList.value) {
    elPageTabList.value.addEventListener('wheel', e => {
      if (e.deltaX > 0 || e.deltaY > 0) {
        turnRight();
      } else if (e.deltaX < 0 || e.deltaY < 0) {
        turnLeft();
      }
    });
    elPageTabList.value.addEventListener('scroll', () => {
      resetHiddenTabItems();
      resetProgressStyle();
      resetScrollConfig();
    });
  }
}, 300);

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["neu-page-tabs", { 'scroll-min': state.isScrollMin, 'scroll-max': state.isScrollMax }]),
    style: _normalizeStyle({ marginLeft: state.hiddenTabItems.length ? '0px' : '15px' })
  }, [
    (state.hiddenTabItems.length)
      ? (_openBlock(), _createBlock(_component_a_dropdown, {
          key: 0,
          trigger: ['click']
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.hiddenTabItems, (item) => {
                  return (_openBlock(), _createBlock(_component_a_menu_item, {
                    key: item?.fullPath
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: item.fullPath
                      }, _toDisplayString(item?.title), 9, _hoisted_1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("a", {
              class: "ant-dropdown-link",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(_component_SvgIcon, {
                size: "20px",
                class: "page-tab-history",
                icon: "history"
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("i", {
      class: "page-tab-action page-tab-action-left",
      onClick: turnLeft
    }, "◀"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", {
        ref_key: "elPageTabList",
        ref: elPageTabList,
        class: "page-tab-list"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabList), (pane, paneIndex) => {
          return (_openBlock(), _createElementBlock("li", {
            key: pane.fullPath,
            class: _normalizeClass(["page-tab-item", { active: _unref(pageTabService).isActive(pane) }]),
            path: pane.fullPath,
            onClick: ($event: any) => (change(paneIndex))
          }, [
            _createElementVNode("span", {
              class: "page-tab-item-label",
              style: _normalizeStyle({ paddingRight: _unref(tabList).length == 1 && paneIndex == 0 ? '20px' : '0px' })
            }, _toDisplayString(pane.title || `[${pane.fullPath}]`), 5),
            (_unref(tabList).length > 1)
              ? (_openBlock(), _createBlock(_component_SvgIcon, {
                  key: 0,
                  class: "page-tab-item-remove",
                  size: "14px",
                  icon: "close",
                  color: "#B2B2B2",
                  "hover-color": "#5961FF",
                  onClick: _withModifiers(($event: any) => (_unref(pageTabService).removeTab(paneIndex)), ["stop"])
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        }), 128))
      ], 512),
      _createElementVNode("div", {
        ref_key: "elPageTabListProgress",
        ref: elPageTabListProgress,
        class: "page-tab-progress",
        style: _normalizeStyle(state.progressStyle)
      }, null, 4)
    ]),
    _createElementVNode("i", {
      class: "page-tab-action page-tab-action-right",
      onClick: turnRight
    }, "▶")
  ], 6))
}
}

})